// Претензионная работа: чистая логика экрана (без Vue и сети) — покрыта unit-тестами.
// Решение Анны 03.11.2026: отдельный раздел в меню, видят и логисты; сегменты — на планшете логиста.

export const LEVEL_TONES = { critical: 'critical', warning: 'warning', info: 'info' }

export const SEGMENT_ICONS = {
  factory_late_cancel: '⚖',
  breakdown_to_us: '⚠',
  downtime_late_act: '⏰',
  downtime_potential: '⏳',
  carrier_refusal: '✋',
  downtime_registered: '📄',
  reports: '✉',
  factory_cancel: '✓',
  offer_withdrawn: '↩',
}

export const OUTCOME_COLUMNS = ['Рейс', 'Маршрут', 'Клиент', 'Погрузка', 'Событие', 'Ответственный']
export const DOWNTIME_COLUMNS = ['Рейс', 'Точка', 'Площадка', 'План', 'Прибытие', 'Ожидание']
export const REPORT_COLUMNS = ['Рейс', 'Где', 'Кто сообщил', 'Когда', 'Что сделала система']

const money = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

export function formatMoney(value) {
  if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) return '—'
  return `${money.format(Number(value))} ₽`
}

// '2026-11-02T14:04' → '02.11 14:04'; ISO с поясом → местное время браузера.
export function formatWhen(iso) {
  if (!iso) return '—'
  const plain = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(iso)
  if (plain) return `${plain[3]}.${plain[2]} ${plain[4]}:${plain[5]}`
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  const p = (n) => String(n).padStart(2, '0')
  return `${p(date.getDate())}.${p(date.getMonth() + 1)} ${p(date.getHours())}:${p(date.getMinutes())}`
}

export function formatDate(isoDate) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate || '')
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '—'
}

function plural(n, one, few, many) {
  const a = Math.abs(n) % 10
  const b = Math.abs(n) % 100
  if (a === 1 && b !== 11) return one
  if (a >= 2 && a <= 4 && (b < 12 || b > 14)) return few
  return many
}

// Срок подачи пакета претензии: «осталось 38 дней» / «последний день» / «просрочено на 2 дня».
export function deadlineText(daysLeft) {
  if (daysLeft === null || daysLeft === undefined) return ''
  if (daysLeft > 0) return `осталось ${daysLeft} ${plural(daysLeft, 'день', 'дня', 'дней')}`
  if (daysLeft === 0) return 'последний день'
  const late = -daysLeft
  return `просрочено на ${late} ${plural(late, 'день', 'дня', 'дней')}`
}

export function deadlineTone(daysLeft) {
  if (daysLeft === null || daysLeft === undefined) return ''
  if (daysLeft < 0) return 'is-overdue'
  if (daysLeft <= 5) return 'is-soon'
  return ''
}

export function waitText(minutes) {
  if (minutes === null || minutes === undefined) return '—'
  const m = Math.max(0, Math.round(minutes))
  const h = Math.floor(m / 60)
  const rest = m % 60
  if (!h) return `${rest} мин`
  return rest ? `${h} ч ${rest} мин` : `${h} ч`
}

// Плашки на планшете: только сегменты, где есть рейсы; срочные — первыми; пустые «горящие» тоже видны
// (зелёный ноль — это хорошая новость, её стоит видеть).
export function stripSegments(segments) {
  const list = Array.isArray(segments) ? segments : []
  return list.filter((s) => s.count > 0 || s.level === 'critical')
}

export function totalCount(segments, level) {
  return (segments || []).filter((s) => !level || s.level === level).reduce((sum, s) => sum + (s.count || 0), 0)
}

export function segmentSubtitle(segment) {
  if (!segment) return ''
  if (segment.key === 'factory_late_cancel' && segment.count) {
    const overdue = segment.overdue ? `, просрочено: ${segment.overdue}` : ''
    return `к претензии ${formatMoney(segment.amount)}${overdue}`
  }
  return ''
}

export function columnsFor(kind) {
  if (kind === 'downtime') return DOWNTIME_COLUMNS
  if (kind === 'report') return REPORT_COLUMNS
  return OUTCOME_COLUMNS
}

export function reportStatusTone(status) {
  if (status === 'registered' || status === 'already') return 'ok'
  if (status === 'rejected') return 'bad'
  return 'muted'
}

// Форма «Сообщить о простое»: номер рейса — цифры, точка — погрузка или выгрузка.
export function validateReport({ tripNumber, operation }) {
  const number = String(tripNumber || '').replace(/\s+/g, '')
  if (!/^\d{4,32}$/.test(number)) return { ok: false, error: 'Укажите номер рейса цифрами' }
  if (!['loading', 'unloading'].includes(operation)) return { ok: false, error: 'Выберите: погрузка или выгрузка' }
  return { ok: true, tripNumber: number }
}

export function filterRows(rows, query) {
  const q = String(query || '').trim().toLowerCase()
  if (!q) return rows || []
  return (rows || []).filter((r) => [r.trip_id, r.route, r.client, r.site, r.responsible, r.reported_by]
    .some((v) => String(v || '').toLowerCase().includes(q)))
}
